export default __webpack_public_path__ + "static/media/logo-list.122838b6.png";